"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCachedServiceCall;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _react = require("react");

var _reactHooks = require("@sprinx/react-hooks");

var dummyApiCall = function dummyApiCall() {
  return Promise.resolve();
};

var dummyCacheHook = function dummyCacheHook() {
  return {
    getItem: function getItem()
    /* key */
    {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", undefined);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setItem: function setItem()
    /* key, value */
    {
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", undefined);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  };
};
/**
 * Hook pro sprostredkovani offline / cached hodnot.
 *
 * Pokusi se hodnotu stahnout z chache. Pri neuspechu, nebo chybe spusti stahovani z API.
 *
 * Vraci `tuple` s hodnotou a change handlerem podobne signarury jako je to u hooku `useState`, s tim rozdilem,
 * ze pokud neni definovan zadny parametr zavola se api a stahnou se cerstva data.
 *
 * @param {string} key Klic do cache.
 * @param {() => Promise} apiCall Funkce vracejici hodnotu
 * @param {() => Cache} cacheHook Hook funkce vracejici `Cache` objekt. `Cache` implementuje funkce
 *   `setItem: (key: string, value: any) => Promise` a `getItem: (key: string) => Promise`.
 * @param {(value: T) => T | undefined} [screwCachedValue] Funkce pro posouzeni spravnosti nacachovane hodnoty.
 *   Vraci zpatky cachovanou hodnotu nebo `undefined` pokud se ma hodnota nacist z API. Vhodne pri update cachovanych
 *   hodnot, napriklad u ceselniku, pripadne je mozne implementovat TTL pro cachovane hodnoty.
 * @param {*} [defaultValue] Defaultna hodnota
 *
 * @returns {Tuple} Tuple `[value: T, reloadData: (void | nextValue: T | (prevV: T) => T | (prevV: T, callResult: T) => T) => void]`, kede:
 *    - `value` - hodnota
 *    - `reloadData` - handler pro update dat. Parametrem muze byt:
 *      - `void` - pro obnoveni dat se zavola API.
 *      - `nextValue: T` - cachovana hodnota se zmeni na `nextValue`.
 *      - `(prevV: T) => T) => void` - update state handler.
 *      - `(prevV: T, callResult: T) => T) => void` - update state handler s apiCall.
 */


function useCachedServiceCall(key, apiCall, cacheHook, screwCachedValue, defaultValue) {
  var cancellablePromise = (0, _reactHooks.useCancellablePromise)();

  screwCachedValue = screwCachedValue || function (v) {
    return v;
  };

  var cache = (0, _reactHooks.usePropHook)(cacheHook || dummyCacheHook);
  apiCall = apiCall || dummyApiCall;

  var _useState = (0, _react.useState)({
    value: defaultValue,
    loading: true
  }),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      _useState2$ = _useState2[0],
      loading = _useState2$.loading,
      value = _useState2$.value,
      setState = _useState2[1];

  function changeValue(nextValue) {
    setState(function (_ref) {
      var pv = _ref.value;
      var nv = typeof nextValue === 'function' ? nextValue(pv) : nextValue;
      cache.setItem(key, nextValue);
      return {
        value: nv,
        loading: false
      };
    });
  }

  function reloadData(nextValue) {
    if (nextValue && typeof nextValue === 'function' && nextValue.length === 2) {
      apiCall().then(function (callResult) {
        return changeValue(function (prevV) {
          return nextValue(prevV, callResult);
        });
      });
    } else if (nextValue) {
      changeValue(nextValue);
    } else {
      apiCall().then(changeValue);
    }
  }

  (0, _react.useEffect)(function () {
    cancellablePromise(cache.getItem(key)).then(function (d) {
      return screwCachedValue(d) || apiCall();
    }, function () {
      return apiCall();
    }).then(changeValue, function (e) {
      console.warn('useCachedServiceCall Error', e); // eslint-disable-line no-console

      changeValue(defaultValue);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [value, loading, reloadData];
}